import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faMapMarkerAlt, 
  faPhoneAlt,
  faEnvelope,
  faClock
} from '@fortawesome/free-solid-svg-icons';

import ContactForm from '../components/sections/ContactForm';

const PageBanner = styled.section`
  background: linear-gradient(rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.7)), url('/images/aesthetes-id-467WNQDb4NA-unsplash.jpg');
  background-size: cover;
  background-position: center;
  padding: 120px 0 80px;
  text-align: center;
  color: #fff;
  
  h1 {
    font-size: 3rem;
    font-weight: 800;
    margin-bottom: 20px;
    
    span {
      color: #ff9800;
    }
    
    @media (max-width: 768px) {
      font-size: 2.3rem;
    }
  }
  
  p {
    font-size: 1.2rem;
    max-width: 700px;
    margin: 0 auto 30px;
    
    @media (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
`;

const ContactInfoSection = styled.section`
  padding: 100px 0;
  background-color: #fff;
  
  .section-title {
    text-align: center;
    margin-bottom: 60px;
    
    h2 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #333;
      margin-bottom: 20px;
      
      span {
        color: #2e7d32;
      }
    }
    
    p {
      color: #666;
      font-size: 1.1rem;
      max-width: 700px;
      margin: 0 auto;
    }
  }
  
  .contact-card {
    height: 100%;
    border: none;
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    text-align: center;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
    }
    
    .contact-icon {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background-color: rgba(46, 125, 50, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2rem;
      color: #2e7d32;
      margin: 0 auto 25px;
      transition: all 0.3s ease;
    }
    
    .card-title {
      font-size: 1.5rem;
      font-weight: 700;
      color: #333;
      margin-bottom: 15px;
    }
    
    .card-text {
      color: #666;
      font-size: 1rem;
      line-height: 1.6;
      margin-bottom: 20px;
      
      a {
        color: #2e7d32;
        font-weight: 600;
        text-decoration: none;
        transition: color 0.3s ease;
        
        &:hover {
          color: #ff9800;
        }
      }
    }
    
    &:hover .contact-icon {
      background-color: #2e7d32;
      color: #fff;
      transform: rotateY(360deg);
      transition: transform 0.8s ease, background-color 0.3s ease, color 0.3s ease;
    }
  }
`;

const MapSection = styled.section`
  padding: 0 0 100px;
  
  .map-container {
    height: 350px;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    
    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
`;

const Contact = () => {
  return (
    <>
      <PageBanner>
        <Container>
          <h1>Contact <span>Us</span></h1>
          <p>
            Have questions about selling your land? We're here to help. 
            Reach out to our team through any of the methods below.
          </p>
        </Container>
      </PageBanner>
      
      <ContactInfoSection>
        <Container>
          {/* 'Get In Touch' section removed as requested */}
          
          <Row className="g-4">
            <Col md={6} lg={3}>
              <Card className="contact-card">
                <div className="contact-icon">
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                </div>
                <Card.Body className="p-0">
                  <Card.Title>Our Office</Card.Title>
                  <Card.Text>
                    14 NE 1st Ave<br />
                    Suite 1403 #140<br />
                    Miami, FL 33132
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={6} lg={3}>
              <Card className="contact-card">
                <div className="contact-icon">
                  <FontAwesomeIcon icon={faPhoneAlt} />
                </div>
                <Card.Body className="p-0">
                  <Card.Title>Phone</Card.Title>
                  <Card.Text>
                    <a href="tel:7864606046">(786) 460-6046</a><br />
                    Monday - Friday<br />
                    9AM - 6PM EST
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={6} lg={3}>
              <Card className="contact-card">
                <div className="contact-icon">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <Card.Body className="p-0">
                  <Card.Title>Email</Card.Title>
                  <Card.Text>
                    <a href="mailto:connect@beringsolutions.com">connect@beringsolutions.com</a><br />
                    We typically respond<br />
                    within 24 hours
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={6} lg={3}>
              <Card className="contact-card">
                <div className="contact-icon">
                  <FontAwesomeIcon icon={faClock} />
                </div>
                <Card.Body className="p-0">
                  <Card.Title>Business Hours</Card.Title>
                  <Card.Text>
                    Monday - Friday: 9AM - 6PM EST<br />
                    Saturday: 10AM - 2PM EST<br />
                    Sunday: Closed
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </ContactInfoSection>
      
      <ContactForm />
      
      <MapSection>
        <Container>
          <div className="map-container">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3592.6878806054078!2d-80.19210752392963!3d25.774136010840465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b69c4af3a091%3A0x3c3f3a26b9944b2e!2s14%20NE%201st%20Ave%2C%20Miami%2C%20FL%2033132!5e0!3m2!1sen!2sus!4v1654312345678!5m2!1sen!2sus" 
              title="Our Office Location" 
              allowFullScreen 
              loading="lazy"
            ></iframe>
          </div>
        </Container>
      </MapSection>
    </>
  );
};

export default Contact;
